import i18n from "../../../../constants/i18n";
import { SUPERVISE_RECEIPT_CONFIGURATION_HEADERS } from "../../../../constants/table-custom-headers/Supervisor";
import { getSupervisorReceiptConfigurationStore } from "../../../../stores/supervisor-store/supervisor-receipt-configuration-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const SupervisorReceiptConfigurationData = withLiteObserverAndTheme(() => {
  const formatedReceiptConfigurationData =
    getSupervisorReceiptConfigurationStore().receiptsConfigurationData.get();

  return (
    <Et3Table
      columns={SUPERVISE_RECEIPT_CONFIGURATION_HEADERS}
      rows={formatedReceiptConfigurationData}
      title={i18n.get("SUPERVISOR_RECEIPT_CONFIGURATION")}
      shouldBeFlagged={false}
      titleKey={"SUPERVISOR_RECEIPT_CONFIGURATION"}
    />
  );
});

export default SupervisorReceiptConfigurationData;
